import { useCallback, useEffect, useRef, useState } from "react";

export const SLIDE_TRANSITION_MS = 150;

/**
 * Bloquea la navegación mientras dura la animación del slide.
 * `lockSlide()` devuelve false si ya está bloqueado (ignorar el clic);
 * si no, bloquea durante la transición y devuelve true.
 */
export const useSlideLock = (duration = SLIDE_TRANSITION_MS) => {
  const [isSlideLocked, setIsSlideLocked] = useState(false);
  const lockedRef = useRef(false);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const lockSlide = useCallback(() => {
    if (lockedRef.current) return false;
    lockedRef.current = true;
    setIsSlideLocked(true);
    timerRef.current = setTimeout(() => {
      lockedRef.current = false;
      setIsSlideLocked(false);
    }, duration);
    return true;
  }, [duration]);

  return { isSlideLocked, lockSlide };
};
